import {
  Button,
  Col,
  Container,
  FloatingLabel,
  Form,
  Placeholder,
  Row,
} from "react-bootstrap";
import { FloatInput, HeadPage } from "src/componentes";
import CategoriasCadastroCode from "./CategoriasCadastro.Code";

const CategoriasCadastroView = () => {
  const { register, errors, handleSubmit, onSubmit, loading } =
    CategoriasCadastroCode();

  return (
    <Container>
      <HeadPage headText="Categorias Cadastro"></HeadPage>
      {!loading ? (
        <>
          <Form noValidate onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Col>
                <Col xs={12}>
                  <FloatInput
                    label="Nome Categoria"
                    errorsMessage={errors.nome}
                    registerField={register("nome")}
                    inputMask="capitalizar"
                  />
                </Col>
              </Col>
            </Row>
            <Row>
              <Col xs={12} className="d-grid mt-3 mb-5">
                <Button type="submit">Confirmar</Button>
              </Col>
            </Row>
          </Form>
        </>
      ) : (
        <Placeholder as={FloatingLabel} animation="glow">
          <Placeholder xs={12} />
        </Placeholder>
      )}
    </Container>
  );
};

export default CategoriasCadastroView;
